
export default function() {
  // On scroll, checks if the sticky navbar should be displayed
  $(window).scroll(() => {
    let scrollTop = $(window).scrollTop();
    if(scrollTop > 500) {
      $('.navbar-container').addClass('navbar--sticky');
    } else {
      $('.navbar-container').removeClass('navbar--sticky');
    }
  });
}
